import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_MacroTag } from '@app/hcs-shared';
export const dispatch_onMacroTagChanged = new ThunderDispatcherV3('__onMacroTagUpdated');
export class ModuleFE_MacroTag_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_MacroTag, dispatch_onMacroTagChanged);
        this._v1 = {};
    }
    __searchFilterMapper = (item) => [item.label];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.entityName,
                results: items.map(item => ({ _id: item._id, uiLabel: item.label }))
            }];
    };
}
export const ModuleFE_MacroTag = new ModuleFE_MacroTag_Class();
//# sourceMappingURL=ModuleFE_MacroTag.js.map